<template>
    <b-modal
        id="create-new-magazine-editor-user"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        modal-class="apprentice-default-modal"
        :ok-title="$t('common.save')"
        ok-variant="primary"
        size="md"
        :title="$t('magazine.add_user')"
        @ok="submitUser"
        @show="clearForm">
        <div class="create-new-editor">
            <div
                class="errors"
                v-if="form.hasError">
                <b-alert
                    v-for="(error, index) in errors"
                    v-if="error.error"
                    :key="index"
                    show
                    variant="danger">
                    {{ error.message }}
                </b-alert>
            </div>

            <div class="name">
                <b-form-group
                    class="editors-name-form-group"
                    :label="$t('common.first_name')"
                    label-for="editor-name-input">
                    <b-form-input
                        id="editor-name-input"
                        v-model="form.name"
                        :placeholder="$t('common.first_name')"
                        required>
                    </b-form-input>
                </b-form-group>

                <b-form-group
                    class="editors-preposition-form-group"
                    :label="$t('magazine.prefix')"
                    label-for="editor-preposition-input">
                    <b-form-input
                        id="editor-preposition-input"
                        v-model="form.preposition"
                        :placeholder="$t('magazine.prefix')">
                    </b-form-input>
                </b-form-group>

                <b-form-group
                    class="editors-surname-form-group"
                    :label="$t('common.last_name')"
                    label-for="editor-surname-input">
                    <b-form-input
                        id="editor-surname-input"
                        v-model="form.surname"
                        :placeholder="$t('common.last_name')"
                        required>
                    </b-form-input>
                </b-form-group>
            </div>

            <b-form-group
                label="E-mail:"
                label-for="editor-email-input">
                <b-form-input
                    id="editor-email-input"
                    v-model="form.email"
                    placeholder="E-mail"
                    required
                    type="email">
                </b-form-input>
            </b-form-group>

            <b-form-group
                label="Rol:"
                label-for="editor-role-input">
                <b-form-select
                    class="apprentice-primary-select"
                    id="editor-role-input"
                    v-model="form.role"
                    required>
                    <option value="null">{{ $t('magazine.choose_a_role') }}</option>
                    <option value="student">{{ $t('magazine.student') }}</option>
                    <option value="teacher">{{ $t('magazine.teacher') }}</option>
                </b-form-select>
            </b-form-group>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-magazine-editor-create-new-user-component',
    props: {
        magazineId: {
            type: Number,
        },
    },
    data() {
        return {
            form: {
                name: '',
                preposition: '',
                surname: '',
                email: '',
                role: null,
                hasError: false,
            },
            errors: {
                name: {
                    error: false,
                    message: this.$t('magazine.first_name_cannot_be_empty'),
                },

                preposition: {
                    error: false,
                    message: '',
                },

                surname: {
                    error: false,
                    message: this.$t('magazine.surname_cannot_be_empty'),
                },

                email: {
                    error: false,
                    message: this.$t('magazine.you_have_not_provided_an_email_yet_or_the_provided_email_is_incorrect'),
                },

                role: {
                    error: false,
                    message: this.$t('magazine.no_role_selected'),
                },
            },
        };
    },

    methods: {
        hasError() {
            this.clearError();

            if (this.form.name === '') {
                this.form.hasError = true;
                this.errors.name.error = true;
            }

            if (this.form.surname === '') {
                this.form.hasError = true;
                this.errors.surname.error = true;
            }

            if (this.form.email === '') {
                this.form.hasError = true;
                this.errors.email.error = true;
            }

            if (this.form.role === null) {
                this.form.hasError = true;
                this.errors.role.error = true;
            }

            return this.form.hasError;
        },

        clearError() {
            this.form.hasError = false;
            this.errors.name.error = false;
            this.errors.surname.error = false;
            this.errors.email.error = false;
            this.errors.role.error = false;
        },

        clearForm() {
            this.clearError();
            this.form.name = '';
            this.form.preposition = '';
            this.form.surname = '';
            this.form.email = '';
            this.form.role = null;
            this.form.hasError = false;
        },

        submitUser(bvModalEvent) {
            if (this.hasError()) {
                bvModalEvent.preventDefault();
                return;
            }

            this.alert.saving();
            this.axios
                .post('magazine/account/store/' + this.magazineId, this.form)
                .then((response) => {
                    this.clearForm();
                    this.$emit('update-users', response.data.user);
                    this.alert.success();
                })
                .catch((error) => {
                    if (error.response.data.errors.email) {
                        this.alert.notice(
                            this.$t('magazine.user_creation_failed'),
                            this.$t('magazine.email_address_already_in_use'),
                            'error',
                            this.$t('common.close'),
                        );
                    } else {
                        this.alert.ajaxError(error);
                    }
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.name {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .editors-name-form-group,
    .editors-surname-form-group {
        width: 33%;
        margin-bottom: 0;
    }

    .editors-preposition-form-group {
        width: calc(33% - 30px);
        margin-left: map-get($grid-gutter-spacing, 'fifteen');
        margin-right: map-get($grid-gutter-spacing, 'fifteen');
        margin-bottom: 0;
    }
}
</style>
